var map = {
	"./synopsis1.jpeg": 8888,
	"./synopsis2.jpeg": 56126,
	"./synopsis3.jpeg": 57509,
	"./synopsis4.jpeg": 20176,
	"./synopsis5.jpeg": 64231
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7013;